import { connect } from 'react-redux';
import { getCurrentUserId } from '../publicSession/selectors';
var mapStateToProps = function (state, _a) {
    var author = _a.author;
    return ({
        isOwner: author ? author.userId === getCurrentUserId(state) : false,
    });
};
export default connect(mapStateToProps);
//# sourceMappingURL=SubmissionDetails.container.js.map